<template>
  <div class="headbar">
    <div class="nav-container">
      <img class="nav-logo" src="@/assets/navbar/nav-logo.png" />
      <div class="nav-right">
        <div class="nav-search">
          <img class="search-icon" src="@/assets/navbar/nav-search.png" />
          <input type="text" v-model="title" class="input" placeholder="请输入关键字" />
          <a class="search-btn" @click="handleSearch">搜索</a>
        </div>
        <img class="nav-member" v-if="isMember" src="@/assets/navbar/member-true.png" />
        <img class="nav-member" v-else src="@/assets/navbar/member-false.png" />
        <img class="nav-head" v-if="!user.avatar || !isLogin " src="@/assets/navbar/nav-head.png" />
        <img class="nav-head" :src="user.avatar" v-if="isLogin && user.avatar" />
        <div class="login-true" v-if="isLogin&&user&&user.nickName" @click="outStatus = !outStatus">
          <span class="nav-name">{{user.nickName}}</span>
          <span class="star-icon"></span>
          <div class="out-box" @click="handleOut" v-if="outStatus">
            <img src="@/assets/common/login-out.png" class="out_icon" />
            退出
          </div>
        </div>
        <div v-else class="login-false">
          <span class="nav-red-word" @click="handleLogo">登录</span>
          <span class="line">|</span>
          <span class="nav-red-word" @click="handleRegist">注册</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import bus from '@/bus';

export default {
  data() {
    return {
      user: {
        avatar: require('@/assets/navbar/nav-head.png'),
        nickName: '',
      },
      title: '',
      isLogin: false,
      isMember: false,
      uuid: 'o8uBxxLF2YmyRhZ2bduTQBw4dsO4',
      outStatus: false,
    };
  },
  computed: {
    username() {},
  },
  created() {
    let openid = this.$route.query.uuid;
    if (openid) {
      localStorage.setItem('website_openid', openid);
    }
    let localopenid = localStorage.getItem('website_openid');
    // 页面刷新获取头部信息
    if (localopenid) {
      this.isLogin = true;
      let url = '/official/user/load/' + localopenid;
      axios.get(url).then(res => {
        if (res.status == 200 && res.data.code == 0) {
          this.user = res.data.data;
          if (this.user.isMember) {
            localStorage.setItem('website_isMember', this.user.isMember);
          }
        } else {
          if (res.status == 200) {
            this.$message.error(res.data.message);
          } else {
            this.$message.error('数据请求失败');
          }
        }
      });
    }
  },
  mounted() {
    this.title = this.$route.query.title;
    let localmember = localStorage.getItem('website_isMember');
    this.isMember = localmember ? true : false;
  },
  methods: {
    handleSearch() {
      let routeUrl = this.$router.resolve({
        path: '/home/searchpage',
        query: { title: this.title },
      });
      window.open(routeUrl.href, '_blank');
    },
    handleLogo() {
      bus.$emit('openLogo');
    },
    handleRegist() {
      bus.$emit('openRegist');
    },
    handleOut() {
      localStorage.clear('website_openid');
      localStorage.clear('website_isMember');
      this.isLogin = false;
      this.user = {};
      let path = this.$route.path;
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.headbar {
  width: 100%;
  height: 0.72rem;
  top: 0;
  position: fixed;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0 1px 0 0 rgba(219, 174, 87, 0.4);
  .nav-container {
    position: relative;
    padding: 0 1.22rem 0 0.29rem;
    height: 0.72rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .nav-logo {
    width: 1.63rem;
    height: 0.45rem;
    margin-right: 1rem;
  }
  .nav-right {
    display: flex;
    align-items: center;
    .nav-search {
      display: inline-block;
      height: 0.48rem;
      width: 5.49rem;
      border: 1px solid #ff5756;
      position: relative;
      flex-shrink: 2;
      border-radius: 0.24rem;
      margin: 0 auto;
      .search-icon {
        position: absolute;
        width: 0.21rem;
        height: 0.23rem;
        top: 0.12rem;
        left: 0.17rem;
      }
      .input {
        position: absolute;
        left: 0.5rem;
        top: 0;
        width: 4rem;
        box-sizing: border-box;
        height: 100%;
        font-size: 0.16rem;
        border: none;
        outline: none;
        background-color: rgba(255, 255, 255, 0.15);
      }
      .search-btn {
        position: absolute;
        top: 0;
        right: 0;
        background: #ff4e4d;
        color: #fff;
        border-top-right-radius: 0.24rem;
        border-bottom-right-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 0.84rem;
        cursor: pointer;
        font-size: 0.2rem;
        font-weight: 500;
        text-align: center;
      }
    }
    .nav-member {
      width: 0.33rem;
      height: 0.31rem;
      margin-left: 0.3rem;
    }
    .nav-head {
      width: 0.48rem;
      height: 0.5rem;
      margin-left: 0.15rem;
      border-radius: 50%;
    }

    .login-true {
      display: flex;
      position: relative;
      align-items: center;
      cursor: pointer;
      .nav-name {
        color: #333333;
        font-weight: bold;
        font-size: 0.2rem;
        margin: 0 0 0 0.1rem;
      }
      .star-icon {
        width: 0;
        height: 0;
        border-style: solid;
        border-color: #69635e #fff #fff #fff;
        border-width: 0.1rem 0.05rem 0 0.05rem;
        margin-left: 0.1rem;
      }
      .out-box {
        position: absolute;
        font-size: 0.16rem;
        min-width: 0.8rem;
        background: #fff;
        height: 0.4rem;
        line-height: 0.4rem;
        bottom: -0.7rem;
        padding: 0 0 0 0.1rem;
      }
    }
    .login-false {
      color: #ff4e4d;
      font-size: 0.2rem;
      margin-left: 0.18rem;
      display: flex;
      width: 1.5rem;
      .nav-red-word {
        font-weight: 500;
        line-height: 0.3rem;
        cursor: pointer;
      }
      .line {
        margin: 0 0.1rem;
      }
    }
    .nav-gry-word {
      color: #333;
      font-weight: 500;
      font-size: 0.16rem;
      line-height: 0.3rem;
      margin-left: 0.18rem;
      cursor: pointer;
    }
  }
}
</style>
